var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalanceWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 120,
    viewBox: "0 0 166 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57128 76.6436L22.8629 32.8822L40.156 76.6436H5.57128ZM160.912 76.6436L143.618 32.8822L126.327 76.6436H160.912ZM25.4476 28.5831L44.1606 76.6436H45.8247C44.6778 87.0667 34.9962 95.2062 23.221 95.2062C11.4458 95.2062 1.7642 87.0667 0.618652 76.6436H1.56802L19.9888 29.3322C16.5699 29.8732 12.9275 30.5774 9.03949 31.4724C8.29179 31.6432 7.53312 31.2306 7.34517 30.55C7.15859 29.8707 7.61406 29.1826 8.36176 29.0131C33.1304 23.3092 58.3805 21.1964 78.5011 40.4583C80.0815 41.8431 81.6345 42.4252 83.0997 42.4539C84.5636 42.4252 86.1166 41.8431 87.6957 40.4583C107.816 21.1964 133.068 23.3092 157.836 29.0131C158.584 29.1826 159.04 29.8707 158.853 30.55C158.665 31.2306 157.906 31.6432 157.159 31.4724C153.386 30.6049 149.846 29.9143 146.511 29.3796L164.915 76.6436H165.863C164.718 87.0667 155.036 95.2062 143.262 95.2062C131.486 95.2062 121.804 87.0667 120.659 76.6436H122.322L141.022 28.6167C107.852 24.729 97.8012 37.6038 90.5273 44.0045V104.034L114.544 119.695H51.7308L75.9548 104.065V44.2538C68.6727 37.9641 58.8346 24.7501 25.4476 28.5831Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1239 27.3931C73.367 10.9271 51.1734 7.13526 31.9295 8.92895L27.5696 13.683C47.3636 10.77 67.8052 13.0448 82.1239 27.3931Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0492 19.981C75.6931 6.80815 60.4689 1.52058 44.7769 0.671722L41.1399 4.61434C56.6042 4.57819 71.3715 8.61928 82.0492 19.981Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9744 35.4857C72.7421 14.0621 40.4345 12.6919 19.9477 17.6096L16.0063 22.6292C39.3729 17.0394 66.1303 16.9828 82.9744 35.4857Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.332 27.3931C92.2399 10.9271 114.815 7.13526 134.392 8.92895L138.826 13.683C118.692 10.77 97.8977 13.0448 83.332 27.3931Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2534 19.981C89.7179 6.80815 105.207 1.52058 121.169 0.671722L124.868 4.61434C109.136 4.57819 94.1149 8.61928 83.2534 19.981Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2319 34.8525C94.8398 13.8693 128.637 13.8331 149.817 19.5919L153.716 24.7698C129.558 18.2207 101.618 17.0603 83.2319 34.8525Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceWhite);
export default __webpack_public_path__ + "static/media/balance-white.5294a00193a171aa273aaedf55a5b442.svg";
export { ForwardRef as ReactComponent };